export default class SwTouchNavigation extends ContaoWebpack.Plugin {
  init() {
    this.options = {
      ...{
        isTouchMode: false,
      },
      ...this.options,
    };

    const isTouchMode =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    if (isTouchMode) {
      this.options.isTouchMode = true;
    }

    window.addEventListener("touchstart", this.handleTouchStart.bind(this), {
      once: true,
    });

    let li = this.el.querySelectorAll("li");
    for (let item of li) {
      item.querySelector("a, span, strong").addEventListener("click", (event) => {
        if (item.classList.contains("submenu") && this.options.isTouchMode) {
          if (!item.classList.contains("clickable")) {
            event.stopPropagation();
            event.preventDefault();
          }
          item.classList.add("clickable");
        }
      });

      item.addEventListener("mouseenter", (event) => {
        if (item.hoverTimeout) {
          clearTimeout(item.hoverTimeout);
        }
        item.classList.add("hover");
      });

      item.addEventListener("mouseleave", (event) => {
        if (item.hoverTimeout) {
          clearTimeout(item.hoverTimeout);
        }
        item.hoverTimeout = setTimeout(
          () => {
            item.classList.remove("hover");
          },
          item.classList.contains("submenu") ? 500 : 100,
        );
      });
    }
  }

  handleTouchStart() {
    this.options.isTouchMode = true;
  }
}
